//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layer from '@/components/layer/layer.vue'
import { toApp } from '@/utils/appBridge.js'

export default {
  data() {
    return {
      posterShow:false,
      Loop:null
    }
  },
  props:{
    poserText:{
      type: String,
      default(){ return '长按图片保存  邀请好友一起玩'}
    },
    posterImg:{
      type: String,
      default(){ return 'https://static.soyoung.com/sy-pre/test0-1596701768210.png'}
    }
  },
  components:{
    Layer
  },
  created() {
    
  },
  methods: {
    show(){
      this.posterShow = true;
    },
    close(){
      this.posterShow = false;
    },
    appDownloadImg() {
      toApp('downloadImg',
            { downloadImgUrl:this.posterImg}
      )
       this.$toast("保存成功");
    },
    posterImgClick(){
         clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
          this.Loop = setTimeout(function() {
            this.STATISTICS('click','sybao_ins_game_save_report_click');
          }.bind(this), 1000)

    }
  },
}
